export function Product() {
  return (
    <section id="product" className="section section-product">
      <div className="section-inner">
        <p className="section-label">Your receiver</p>
        <h2>Private inbox on your machine</h2>
        <p className="section-lead">
          Install once. Approve each transfer. Large files land straight on disk
          over Turbo TCP — free, direct, and never parked in someone else’s cloud.
        </p>

        <figure className="shot-block">
          <img
            src="/images/mac-receiver-pairing.png"
            alt="macOS PairBolt Receiver pairing screen with code K7M2QX9P and QR"
            width={980}
            height={720}
            loading="lazy"
            decoding="async"
          />
          <figcaption>
            Pairing and tokens — mint one or many codes with folder, quota, and
            speed limits. Turbo TCP stays ready on your machine.
          </figcaption>
        </figure>

        <figure className="shot-block">
          <img
            src="/images/mac-receiver-approval.png"
            alt="macOS PairBolt Receiver with token policy, pending approval, and an active transfer"
            width={980}
            height={780}
            loading="lazy"
            decoding="async"
          />
          <figcaption>
            Approve first — each token can require approval, then large transfers
            land privately on the path you chose.
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
